import { gql } from '@apollo/client'

export const MUTATION_EMPLOYEE_OFFBOARDING = gql`
  mutation mutationEmployeeOffboarding($id: ID!, $exitDate: Time!) {
    employeeOffboarding(input: { employeeID: $id, exitDate: $exitDate })
  }
`
